import React, { useState } from "react";
import { Modal, Button, TextInput, Textarea, Text } from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { showNotification } from "@mantine/notifications";
import { formatDate } from "../utilities/utilities";
import NewDocumentUploader from "./NewDocumentUploader/NewDocumentUploader";
import useMultiFileUpload from "../hooks/useMultiFileUpload";
import { closeAgreement } from "../utilities/apis/agreements";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers";
import colors from "../utilities/design";

const CloseAgreementModal = ({ opened, onClose, agreementData }) => {
  const [closeDate, setCloseDate] = useState(new Date().toISOString().split('T')[0]);
  // const [closeDate, setCloseDate] = useState(new Date().toISOString());
  const [closeReason, setCloseReason] = useState("");
  const [loading, setLoading] = useState(false);

  const multiUploadArgs = useMultiFileUpload({
    loadFromParent: false,
    parent: "agreement",
    parentId: agreementData?.agreementId,
  });

  const handleProceed = async () => {
    if (!closeReason.trim()) {
      showNotification({
        color: "red",
        title: "Error",
        message: "Please provide a Reason for closing the agreement.",
      });
      return;
    }

    setLoading(true);
    try {
      const uploadedFiles = multiUploadArgs.finalFiles;
      const response = await apiWrapWithErrorWithData(
        closeAgreement({
          agreementId: agreementData.agreementId,
          actionText: "force_closed",
          closeDate,
          closeReason,
        })
      );

      if (response.success) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Agreement closed successfully.",
        });
        onClose();
      } else {
        showNotification({
          color: "red",
          title: "Error",
          message: "Failed to close agreement.",
        });
      }
    } catch (error) {
      showNotification({
        color: "red",
        title: "Error",
        message: "An error occurred while closing the agreement.",
      });
    }
    setLoading(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Close Agreement"
      size="lg"
    >
      <div className="space-y-4">
        <div>
          <Text size="sm" weight={500}>contract end date</Text>
          <TextInput
            value={formatDate(agreementData?.wholeAgreement?.dueDateOfContract)}
            readOnly
            disabled
          />
        </div>

        <div>
          <Text size="sm" weight={500}>date of close contract *</Text>
          <TextInput
            type="date"
            value={closeDate}
            onChange={(e) => setCloseDate(e.target.value)}
          />
        </div>

        <div>
          <Text size="sm" weight={500}>document upload</Text>
          <NewDocumentUploader multiUploadArgs={multiUploadArgs} />
        </div>

        <div>
          <Text size="sm" weight={500}>reason to close *</Text>
          <Textarea
            required
            placeholder="enter reason for closing the agreement..."
            value={closeReason}
            onChange={(e) => setCloseReason(e.target.value)}
            minRows={3}
          />
        </div>

        <div className="flex justify-end space-x-2 pt-4">
          <Button variant="outline" onClick={onClose}>
            cancel
          </Button>
          <Button
            onClick={handleProceed}
            disabled={loading}
            style={{ backgroundColor: colors.primary }}
          >
            {loading ? (
              <BeatLoader size={10} color="#fff" />
            ) : (
              "proceed"
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloseAgreementModal;
